var app = angular.module("leonardo");

var ApprovalStates = function ($stateProvider) {
  $stateProvider.state('approvals', {
    url: "/approvals",
    parent: 'authenticated.layout-main',
    title: 'My Approvals',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      },
      'content': {
        templateUrl: 'views/templates/approvals/tasks.html',
      },
      'filters': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ApprovalListFilters'
      }
    },
    ncyBreadcrumb: {
      label: 'My Approvals'
    }
  });
};

app.config(['$stateProvider', ApprovalStates]);
